"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const shared_styles_1 = require("../common/shared-styles");
const StyledButton = (0, styled_components_1.default)(Button_1.default) `
  ${shared_styles_1.baseButtonStyles}
  ${(props) => props.styles};

  &.Mui-disabled:disabled {
    ${shared_styles_1.disabledButtonStyles};
  }

  ${(props) => props.$showFocusRing && shared_styles_1.defaultFocusStyles}

  .MuiTouchRipple-ripple {
    color: ${({ $touchRippleColor }) => $touchRippleColor};

    &.MuiTouchRipple-rippleVisible {
      opacity: 1 !important;
    }
  }
`;
/**
 * _Base Button_
 *
 * Non-opinionated button base. Contains minimum default styles and touch ripple animation for all buttons.
 *
 */
const BaseButton = ({ touchRippleColor, showFocusRing, children, ...rest }) => {
    return ((0, jsx_runtime_1.jsx)(StyledButton, { "$showFocusRing": showFocusRing, "$touchRippleColor": touchRippleColor, disableFocusRipple: true, ...rest, children: (0, jsx_runtime_1.jsx)("span", { children: children }) }));
};
exports.default = BaseButton;
//# sourceMappingURL=index.js.map